import $ from 'jquery';
import { showBodyMask, hideBodyMask } from '../body-mask/c-body-mask';

const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-menu-trigger');
    const $mobileMenu = $('.c-mobile-menu');
    const $fixedHeader = $('.js-flex-fixed');
    const activeClass = 'is-active';

    // Early return
    if (!$trigger.length) { return; }

    $trigger.on('click', () => {
        $trigger.toggleClass(activeClass);
        $mobileMenu.toggleClass(activeClass);
        $fixedHeader.toggleClass('perm-fixed');
        $fixedHeader.addClass('fixed');
        $fixedHeader.css('top', 0);

        if ($mobileMenu.hasClass(activeClass)) {
            showBodyMask();
        } else {
            $mobileMenu.find('.menu-holder').removeClass('sub-active');
            $mobileMenu.find('.menu-item .c-mobile-submenu').removeClass('active');
            hideBodyMask();
        }
    });
};

function mobileMenuSubmenuExpand() {
    const $expandControls = $('.c-mobile-menu .menu-item > span');
    if (!$expandControls.length) { return; }

    $expandControls.click(function () {
        $(this).closest('.menu-item').find('.c-mobile-submenu').toggleClass('active');
        $(this).closest('.menu-holder').toggleClass('sub-active');
    });
}

function mobileSubmenuClose() {
    const $closeControls = $('.c-mobile-menu .menu-item .js-close-submenu');
    if (!$closeControls.length) { return; }

    $closeControls.click(function () {
        $(this).closest('.c-mobile-submenu').removeClass('active');
        $(this).closest('.menu-holder').removeClass('sub-active');
    });
}

export default function closeMobileNav() {
    const $trigger = $('.c-mobile-menu-trigger');
    const $mobileMenu = $('.c-mobile-menu');
    const $fixedHeader = $('.js-flex-fixed');
    const activeClass = 'is-active';

    $trigger.removeClass(activeClass);
    $mobileMenu.removeClass(activeClass);
    $mobileMenu.find('.menu-holder').removeClass('sub-active');
    $mobileMenu.find('.menu-item .c-mobile-submenu').removeClass('active');
    $fixedHeader.removeClass('perm-fixed');
    $fixedHeader.addClass('fixed');
    $fixedHeader.css('top', 0);
}

// doc ready
$(() => {
    mobileMenuTriggerInit();
    mobileMenuSubmenuExpand();
    mobileSubmenuClose();
});



// WEBPACK FOOTER //
// ./src/components/mobile-menu/c-mobile-menu.js